/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
*/

import type { SVGProps } from "react"

const User = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" {...props} fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.5 4C10.567 4 8.99996 5.567 8.99996 7.5C8.99996 9.433 10.567 11 12.5 11C14.433 11 16 9.433 16 7.5C16 5.567 14.433 4 12.5 4ZM6.99996 7.5C6.99996 4.46243 9.46239 2 12.5 2C15.5375 2 18 4.46243 18 7.5C18 10.5376 15.5375 13 12.5 13C9.46239 13 6.99996 10.5376 6.99996 7.5ZM9.82623 14.5C9.88329 14.5 9.94119 14.5 9.99997 14.5H15C15.0587 14.5 15.1166 14.5 15.1737 14.5C16.401 14.4995 17.239 14.4992 17.9514 14.7153C19.5494 15.2 20.7999 16.4506 21.2847 18.0486C21.5008 18.761 21.5005 19.599 21.5 20.8263C21.5 20.8833 21.5 20.9412 21.5 21C21.5 21.5523 21.0522 22 20.5 22C19.9477 22 19.5 21.5523 19.5 21C19.5 19.5317 19.4891 19.0192 19.3708 18.6291C19.0799 17.6703 18.3296 16.92 17.3708 16.6292C16.9808 16.5108 16.4683 16.5 15 16.5H9.99997C8.53164 16.5 8.01917 16.5108 7.62911 16.6292C6.6703 16.92 5.91999 17.6703 5.62914 18.6291C5.51082 19.0192 5.49996 19.5317 5.49996 21C5.49996 21.5523 5.05225 22 4.49996 22C3.94768 22 3.49996 21.5523 3.49996 21C3.49996 20.9412 3.49994 20.8833 3.49992 20.8263C3.49946 19.599 3.49915 18.761 3.71526 18.0486C4.20001 16.4506 5.45053 15.2 7.04853 14.7153C7.76094 14.4992 8.59895 14.4995 9.82623 14.5Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
)

export default User
